import { Link } from 'react-router-dom';

function productLineName(original) {
  return (
    <Link to={`/serviceadministratorproductlines/edit/${original?.id}`}>
      {original?.productLineName || ''}
    </Link>
  );
}

function productLineCode(original) {
  return original?.productLineCode || '';
}

function status(original) {
  return original?.status ? 'Active' : 'In-Active';
}

export { productLineName, productLineCode, status };
